import { render, staticRenderFns } from "./NewWalletCreditingPortal.vue?vue&type=template&id=0dd4f52c&scoped=true&"
import script from "./NewWalletCreditingPortal.vue?vue&type=script&lang=js&"
export * from "./NewWalletCreditingPortal.vue?vue&type=script&lang=js&"
import style0 from "./NewWalletCreditingPortal.vue?vue&type=style&index=0&id=0dd4f52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4f52c",
  null
  
)

export default component.exports